import { RouteConfig } from 'vue-router';

export class MemoirRoute {
  static LEGACY_LETTERS: RouteConfig = {
    name: 'legacy-letters',
    path: 'legacy-letters'
  };
}
